import { Theme } from '@mui/material'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  subHeadingContainer: {
    margin: theme.spacing(3, 0),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  subHeading: {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.labraText.tertiary,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  actionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: 'fit-content',
  },
}))
